<template>
    <up-low-paging @pageChange="pageChange" :pagingInfo="pagingInfo">
        <Loading :show="isLoading"></Loading>
        <div>

            <div v-if="filter!==null">
                <div v-if="filter.keyword!==null">
                    <span class="btn btn-default"> {{lang.common.keyword}}:{{filter.keyword}} </span>
                </div>
                <div>
                    <div role="group" class="btn-group" v-for="fCat in filterCats">
                        <button type="button" class="btn btn-default">{{fCat.parent.name}}/{{fCat.cat.name}}</button>
                        <button type="button" class="btn btn-default"><span class="glyphicon glyphicon-check"></span></button>
                    </div>
                    <div role="group" class="btn-group" v-for="fTag in filterTags">
                        <button type="button" class="btn btn-default"> {{fTag.parent.name}}/{{fTag.cat.name}}</button>
                        <button type="button" class="btn btn-default"><span class="glyphicon glyphicon-check"></span></button>
                    </div>
                    <div role="group" class="btn-group" v-if="filterCats.length>0 || filterTags.length>0 || filter.keyword!==null">
                        <router-link to="/articles">
                            <button type="button" class="btn btn-default">{{lang.common.removeFilter}}</button>
                            <button type="button" class="btn btn-default">
                                <span class="glyphicon glyphicon-remove"></span>
                            </button>
                        </router-link>
                    </div>
                </div>
            </div>
            <div v-if="items!==null && items.length===0">
                <div class="alert alert-warning" role="alert" style="text-align:center;">
                    <span>{{lang.common.noData}}</span>
                </div>
            </div>

            <div v-for="item in items">
                <info-card :item="item"></info-card>
            </div>
        </div>
    </up-low-paging>
</template>
<script>
    import UpLowPaging from './base/UpLowPaging.vue';
    import Loading from './base/Loading.vue';
    import InfoCard from './cards/infotext.vue';
    export default {
        props: ["filterInfo"],
        components: {
            InfoCard: InfoCard,
            UpLowPaging: UpLowPaging,
            Loading: Loading
        },
        computed: {
            lang: function () {
                return this.$store.getters.lang;
            },
            apiClient: function () {
                return this.mxnAgxApi.articlesApiClient;
            },
            filterCats: function () {
                if (!this.filterInfo) return [];
                if (this.filterInfo === null || this.filter == null) return [];
                return this.getMatchedCatPair(this.filterInfo.articles, this.filter.cats);
            },
            filterTags: function () {
                if (!this.filterInfo) return [];
                if (this.filterInfo === null || this.filter == null) return [];
                return this.getMatchedCatPair(this.filterInfo.itemTagCats, this.filter.tags);
            }
        },
        methods: {
            getMatchedCatPair: function (poolArr, idsArr) {
                var catGroups = poolArr;
                var cats = idsArr;
                var retPairs = [];
                for (var i = 0; i < cats.length; i++) {
                    var catId = cats[i];
                    for (var g = 0; g < catGroups.length; g++) {
                        var grp = catGroups[g];
                        var subs = grp.childs;
                        for (var s = 0; s < subs.length; s++) {
                            var sCat = subs[s];
                            if (sCat.catId === catId) {
                                retPairs.push({ parent: grp.parent, cat: sCat });
                            }
                        }
                    }
                }
                return retPairs;
            },
            getRoutePage: function () {
                var rPage = this.$route.query.page;
                if (typeof rPage === "undefined") {
                    rPage = 1;
                };
                return rPage;
            },
            pageChange: function (page) {
                var route = this.$router.currentRoute;
                var query = route.query;
                var newQuery = {};
                for (var n in query) {
                    newQuery[n] = query[n];
                };
                newQuery.page = page;
                var newRoute = {
                    name: "articles", query: newQuery
                };
                this.$router.push(newRoute);
            },
            textChange: function (page, totalPage) {
                this.page = page;
                this.totalPage = totalPage;
            },
            loadItems: function () {
                var queryString = this.$route.fullPath;
                queryString = queryString.split('?')[1];
                if (queryString == null) {
                    queryString = "";
                }
                var $that = this;
                $that.isLoading = true;
                this.apiClient.getItemsPrms(queryString).done((data) => {
                    this.isLoading = false;
                    var filter = data.filter;
                    this.filter = filter;
                    this.pagingInfo = { page: filter.page, pageSize: filter.pageSize, count: filter.count };
                    this.items = data.posts;
                    this.loadedQuery = queryString;
                });
            },
            getQueryString: function () {
                var queryString = this.$route.fullPath;
                queryString = queryString.split('?')[1];
                if (queryString == null) {
                    queryString = "";
                }
                return queryString;
            },
            initPaging: function () {
                this.loadItems();
            }
        },
        data: function () {
            return {
                items: null,
                page: 1,
                totalPage: 1,
                pagingInfo: { page: 1, pageSize: 1, count: 1 },
                filter: null,
                isLoading: false,
                loadedQuery: null,
                timeStamp: new Date().toLocaleString()
            }
        },
        watch: {
            '$route'(to, from) {
                console.log("route change fired:" + this.timeStamp);
                if (to.name === 'articles') {
                    this.page = this.getRoutePage();
                    var qstr = this.getQueryString();
                    console.log('loadedQuery:', this.loadedQuery, ',current query:', qstr, ',', this.loadedQuery === qstr);
                    if (qstr === this.loadedQuery) {
                        return;
                    }
                    this.loadItems(qstr);
                }
            }
        },
        mounted: function () {
            this.initPaging();
        }

    }
</script>